import api from "@/lib/axios";
import { useMutation, useQuery } from "@tanstack/react-query";

export const useAddEntranceTicket = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/entrance-ticket", body);
      return res.data;
    },
    onSuccess: (data) => {
      // handle success if needed
    },
    onError: (error) => {
      console.error("Failed to add user:", error);
    },
  });
};

export const useGetAllEntranceTickets = () => {
  return useQuery({
    queryKey: ["entrance-tickets"],
    queryFn: async () => {
      const res = await api.get("/entrance-ticket");
      return res.data;
    },
  });
};

export const useGetEntranceTicket = (id: number) => {
  return useQuery({
    queryKey: ["entrance-ticket", id],
    queryFn: async () => {
      const res = await api.get(`/entrance-ticket/${id}`);
      return res.data;
    },
  });
};

export const useUpdateEntranceTicket = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.put(`/entrance-ticket/${body.id}`, body);
      return res.data;
    },
    onSuccess: (data) => {
      // handle success if needed
    },
    onError: (error) => {
      console.error("Failed to add user:", error);
    },
  });
};

export const useDeleteEntranceTicket = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.delete("/entrance-ticket", {
        data: payload,
      });

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};
